import React, { useState } from "react";
import { ModalX } from "../../../components";
import { Button, Checkbox, Input, Option, Select, Textarea } from "@material-tailwind/react";
import { AddEngagement } from "../../../services/backend";
import { convertToPresentableText, Notify, NotifyError } from "../../../utils/functions";
import { CONTACT_TYPES_ENUM } from "../../../utils/enums";

const EngagementFormModal = ({ isOpen, onClose, leadId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    contactMethod: '',
    notes: '',
    outcome: '',
    followUpRequired: false
  });

  // Reset form when modal opens
  React.useEffect(() => {
    if (isOpen) {
      setFormData({
        date: new Date().toISOString().split('T')[0],
        contactMethod: '',
        notes: '',
        outcome: '',
        followUpRequired: false
      });
    }
  }, [isOpen]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.contactMethod) {
      Notify('Please select a contact method', 'error');
      return;
    }

    setLoading(true);
    try {
      await AddEngagement(leadId, formData);
      Notify('Engagement added successfully', 'success');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Error adding engagement', error);
      NotifyError('Failed to add engagement', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalX
      isOpen={isOpen}
      onClose={onClose}
      title="Add Follow-up"
      maxWidth="xl"
    >
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div className="flex gap-4 flex-col md:flex-row">
            <Input
              label="Date"
              name="date"
              type="datetime-local"
              value={formData.date}
              onChange={handleInputChange}
              required
            />
            <Select
              label="Contact Method"
              value={formData.contactMethod}
              onChange={(value) => setFormData({ ...formData, contactMethod: value })}
              required
            >
              {CONTACT_TYPES_ENUM.map((method, index) => (
                <Option key={index} value={method}>
                  {convertToPresentableText(method)}
                </Option>
              ))}
            </Select>
          </div>

          <Textarea
            label="Notes"
            name="notes"
            value={formData.notes}
            onChange={handleInputChange}
          />

          <Textarea
            label="Outcome"
            name="outcome"
            value={formData.outcome}
            onChange={handleInputChange}
            required
          />

          <Checkbox
            name="followUpRequired"
            checked={formData.followUpRequired}
            onChange={handleCheckBoxChange}
            label="Follow-up Required"
          />
        </div>

        <hr className="my-4" />

        <div className="flex justify-end space-x-2">
          <Button
            onClick={onClose}
            className="rounded-full"
            variant="text"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="rounded-full"
            disabled={loading}
          >
            Add Engagement
          </Button>
        </div>
      </form>
    </ModalX>
  );
};

export default EngagementFormModal;